import { iconStyle } from 'shared/consts'
import { IonIcon } from '@ionic/react'
import  { personCircleOutline, settingsOutline, tvOutline } from 'ionicons/icons'

const MenuIcons = {
    personCircleOutline: {
        active: <IonIcon icon={personCircleOutline} className='ionicon' style={{color: iconStyle.colorActive, fontSize: iconStyle.size}} />,
        inactive: <IonIcon icon={personCircleOutline} className='ionicon' style={{color: iconStyle.color, fontSize: iconStyle.size}} />,
    },
    settingsOutline: {
        active: <IonIcon icon={settingsOutline} className='ionicon' style={{color: iconStyle.colorActive, fontSize: iconStyle.size}} />,
        inactive: <IonIcon icon={settingsOutline} className='ionicon' style={{color: iconStyle.color, fontSize: iconStyle.size}} />,
    },
    tvOutline: {
        active: <IonIcon icon={tvOutline} className='ionicon' style={{color: iconStyle.colorActive, fontSize: iconStyle.size}} />,
        inactive: <IonIcon icon={tvOutline} className='ionicon' style={{color: iconStyle.color, fontSize: iconStyle.size}} />
    }
}

export default MenuIcons